/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/instafeed.js":
/*!*******************************************!*\
  !*** ./zrc/scripts/sections/instafeed.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n/* provided dependency */ var $ = __webpack_require__(/*! jquery */ \"./node_modules/jquery/dist/jquery.js\");\n\nclass Instafeed extends HTMLElement {\n  constructor() {\n    super();\n    this.container = this;\n    this.waitForAppToLoad();\n  }\n  waitForAppToLoad() {\n    const $target = this.container.querySelector('#insta-feed');\n\n    // eslint-disable-next-line @shopify/prefer-early-return\n    const observer = new window.MutationObserver(() => {\n      if ($target.firstChild.nodeName !== \"IMG\") {\n        this.prepareCarousel();\n        observer.disconnect();\n      }\n    });\n    observer.observe($target, {\n      childList: true\n    });\n  }\n  prepareCarousel() {\n    const $instafeed = $(this.container).find('#insta-feed');\n    const $carousel = $(this.container).find('.swiper-wrapper');\n    const $items = $instafeed.find('.instafeed-new-layout-item');\n    $items.each((index, element) => {\n      const $item = $(element);\n      const $slide = $('<div class=\"swiper-slide if-slide\"></div>');\n      const $image = $item.find('img');\n      $item.find('.instafeed-container').addClass('if-image-container aspect-ratio-container').removeAttr('style').add($image).removeAttr('style');\n      $image.removeAttr('class');\n      $slide.append($item);\n      $carousel.append($slide);\n    });\n    this.initCarousel();\n  }\n  initCarousel() {\n    const $instafeedCarousel = document.querySelector('.if-carousel');\n    const swiper = new swiper__WEBPACK_IMPORTED_MODULE_0__.default($instafeedCarousel, {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.Navigation],\n      init: false,\n      loop: false,\n      longSwipesRatio: 0,\n      navigation: {\n        prevEl: this.container.querySelector('.swiper-button.prev'),\n        nextEl: this.container.querySelector('.swiper-button.next')\n      },\n      speed: 500,\n      slidesPerGroup: 1,\n      preloadImages: false,\n      resistanceRatio: 0,\n      slidesPerView: 'auto',\n      spaceBetween: 0,\n      on: {\n        init() {\n          $('.instafeed').addClass('swiper-initialized');\n        }\n      },\n      breakpoints: {\n        1000: {\n          slidesPerView: 4,\n          spaceBetween: 17\n        }\n      }\n    });\n    swiper.init();\n  }\n}\ncustomElements.define('instafeed-carousel', Instafeed);//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/instafeed.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"instafeed": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/instafeed.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;